import { KtVueComponentsOptions } from 'kt-vuecomponents';
import { fi as libraryFi, en as libraryEn, sv as librarySv } from 'kt-vuecomponents/locales';
import customFi from '../locales/fi.json';
import customEn from '../locales/en.json';
import customSv from '../locales/sv.json';

export const options: KtVueComponentsOptions = {
  i18n: {
    messages: {
      fi: {
        ...libraryFi,
        ...customFi,
      },
      en: {
        ...libraryEn,
        ...customEn,
      },
      sv: {
        ...librarySv,
        ...customSv,
      },
    },
  },
};
